<ion-app>
    <ion-split-pane contentId="main-content">

        <ion-menu contentId="main-content"
                  type="overlay"
                  [swipeGesture]="false"
                  [disabled]="!authService.isLoggedIn()">

            <ion-header class="ion-padding">
                <ion-toolbar>
                    @if (user) {
                        <h3>
                            Hi, {{ user.name }}!
                        </h3>

                        <ion-note>ID: {{ user.external_id }}</ion-note>
                    }
                </ion-toolbar>
            </ion-header>

            <ion-content>
                <ion-list>
                    @for (p of appPages; track p; let i = $index) {
                        <ion-menu-toggle auto-hide="false">
                            <ion-item routerDirection="root"
                                      class="sidebar-item"
                                      [routerLink]="[p.url]"
                                      [queryParams]="null"
                                      lines="none"
                                      [detail]="false"
                                      routerLinkActive="selected">
                                @if (p.icon) {
                                    <ion-icon aria-hidden="true"
                                              slot="start"
                                              [name]="p.icon"></ion-icon>
                                }

                                <ion-label>
                                    {{ p.title }}
                                </ion-label>
                            </ion-item>
                        </ion-menu-toggle>
                    }
                </ion-list>
            </ion-content>

            <ion-footer class="ion-no-border">
                <ion-toolbar>
                    <ion-list lines="none">
                        <ion-menu-toggle auto-hide="false">
                            <ion-item [button]="true" (click)="logout()">
                                <ion-icon slot="start" ios="log-out-outline" md="log-out-sharp"></ion-icon>
                                <ion-label>Sign Out</ion-label>
                            </ion-item>
                        </ion-menu-toggle>
                    </ion-list>

                    @if (appInfo) {
                        <ion-button
                            size="small"
                            color="medium"
                            fill="clear"
                            (click)="appInfoService.showAppInfo()"
                        >
                            {{ appInfo }}
                        </ion-button>
                    }
                </ion-toolbar>
            </ion-footer>

        </ion-menu>

        <ion-router-outlet id="main-content"></ion-router-outlet>

    </ion-split-pane>
</ion-app>
